import { render } from "./LegoRadioInput.vue?vue&type=template&id=6ddea29a&scoped=true"
import script from "./LegoRadioInput.vue?vue&type=script&lang=js"
export * from "./LegoRadioInput.vue?vue&type=script&lang=js"

import "./LegoRadioInput.vue?vue&type=style&index=0&id=6ddea29a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6ddea29a"

export default script